import CustomButton from '../../../components/stateless/customButton/CustomButton';
import { NavLink, useLocation } from 'react-router-dom';
import React from "react";
import './PrivateHeader.scss';

interface IPrivateHeaderProps {
    toggleDrawer: () => void;
    drawerStatus: boolean;
}

const PrivateHeader = (props: IPrivateHeaderProps) => {

    // The following gets the header label based on the route
    const location = useLocation();
    // expression matchs /state/dashboard to set the correct selection on the drawer
    var rx = /\/[a-z]+\/[a-z]+/g;
    var base: any = rx.exec(location.pathname);
    var words = base.input.toString().split("/");
    var lastWordIsNum = /^\d+$/.test(words[words.length - 1]);
    let headerLabel = words[words.length - 1 - (lastWordIsNum ? 1 : 0)].replace(/-/gi, ' ').toUpperCase();


    return (
        <div className="full-width">
            <header className="private-header">
                <CustomButton className="hamburger" icon={props.drawerStatus ? "x" : "menu"}
                    onClick={props.toggleDrawer}
                    themeColor="warning"
                    title="toggle menu" />
                <div className="private-header-menu">
                    <div className="location-label">
                        <div className="private-header-label">{headerLabel}</div>
                    </div>

                    {/*<NavLink className="nav-link" to='/proposed'>*/}
                    {/*    <span className="k-icon k-i-logout">&nbsp;</span>Logout*/}
                    {/*</NavLink>*/}

                </div>
            </header>
        </div>
    )
}

export default PrivateHeader
